"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * Vendors
 */
require("lazysizes");
require("./vendor/ls.object-fit");
/**
 * Import Functions
 */
const global_1 = require("./functions/global");
const scrollHeader_1 = require("./functions/scrollHeader");
const mainMenu_1 = require("./functions/mainMenu");
const mobilePanel_1 = require("./functions/mobilePanel");
const sliders_1 = require("./functions/sliders");
const accordion_1 = require("./functions/accordion");
const ajaxFilter_1 = require("./functions/ajaxFilter");
const forms_1 = require("./functions/forms");
const wrapperLinks_1 = require("./functions/wrapperLinks");
const animateIn_1 = require("./functions/animateIn");
const dataCounter_1 = require("./functions/dataCounter");
const smoothScroll_1 = require("./functions/smoothScroll");
/**
 * Call Functions
 */
(0, global_1.global)();
(0, global_1.accessibility)();
(0, global_1.copyToClipboard)();
(0, scrollHeader_1.scrollHeader)();
(0, mainMenu_1.mainMenu)();
(0, mobilePanel_1.mobilePanel)();
(0, sliders_1.sliders)();
(0, accordion_1.accordion)();
(0, ajaxFilter_1.ajaxFilter)();
(0, forms_1.forms)();
(0, forms_1.inputReactiveLabel)();
(0, wrapperLinks_1.wrapperLinks)();
(0, animateIn_1.animateIn)();
(0, dataCounter_1.dataCounter)();
(0, smoothScroll_1.smoothScroll)();
